import React, { useContext, useState } from "react";
import {
    Button,
    Dropdown,
    Icon,
    InputNumber,
    Menu,
    message,
    Modal
} from "antd";
import styles from "./index.module.scss";
import classNames from "classnames";
import useModalHandler from "utils/useModalHandler";
import useRequestFn from "utils/useRequestFn";
import { setScore } from "service/discuss";
import { AnswerContent, DiscussContent } from "../../../../context";

export function AnswerScore() {
    const modal = useModalHandler();
    const [customScore, setCustomScore] = useState(0);
    const { answerData } = useContext(AnswerContent);
    const { updateDiscussDetail } = useContext(DiscussContent);

    const { topicUuid, uuid, score } = answerData;

    function onOpenCustomNumber() {
        setCustomScore(score);
        modal.open();
    }

    async function onCustomNumber() {
        await onSetScore(customScore);
        setCustomScore(0);
        modal.close();
    }

    const [onSetScore, { loading }] = useRequestFn(async (score: number) => {
        try {
            await setScore(topicUuid, uuid, score);
            updateDiscussDetail();
            modal.close();
            message.success("修改成功!");
        } catch (e) {
            Modal.error({ content: "修改失败" });
        }
    });

    const menu = (
        <Menu style={{ textAlign: "center" }}>
            <Menu.Item onClick={() => onSetScore(1)}>+1分</Menu.Item>
            <Menu.Item onClick={() => onSetScore(2)}>+2分</Menu.Item>
            <Menu.Item onClick={() => onSetScore(3)}>+3分</Menu.Item>
            <Menu.Item onClick={onOpenCustomNumber}>自定义分值</Menu.Item>
        </Menu>
    );

    return (
        <React.Fragment>
            <Dropdown overlay={menu} placement="bottomCenter">
                <Button
                    type="link"
                    className={classNames(styles.button, {
                        [styles.noScore]: !score
                    })}>
                    {score ? `+${score}分` : "不加分"}
                    <Icon type="down" />
                </Button>
            </Dropdown>

            <Modal
                title="自定义分值"
                width={300}
                visible={modal.visible}
                onCancel={modal.close}
                destroyOnClose
                onOk={onCustomNumber}
                confirmLoading={loading}>
                <div className={styles.changeScore}>
                    分值:
                    <InputNumber
                        className={styles.inputNumber}
                        precision={0}
                        min={0}
                        max={100}
                        value={customScore}
                        onChange={v => setCustomScore(v || 0)}
                        autoFocus
                        onPressEnter={onCustomNumber}
                    />
                </div>
            </Modal>
        </React.Fragment>
    );
}
